<template>
    <facet-template :title="title" class="minmax-facet">
    <div slot="facetLabel">
            <div class="d-flex align-items-center flex-wrap">
                <div class="mr-2">{{ title }}</div>
                <small
                    v-if="value"
                    class="font-italic font-weight-normal"
                >
                    (1)
                </small>
            </div>
        </div>
        <div class="d-flex justify-content-between">
            <b-form-select :options="options" :value="value" @input="input" />
        </div>
    </facet-template>
</template>

<script>
import FacetTemplate from "./FacetTemplate";

export default {
    components: {
        FacetTemplate,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        value: {
            type: [String, Number, Array],
            required: false,
            default: null,
        },
        options: {
            type: Array,
            required: true,
        },
    },

    methods: {
        input(e) {
            this.$emit("input", e);
        },
    },
};
</script>
